import { render, staticRenderFns } from "./DropdownSlider.vue?vue&type=template&id=3537f8c0&scoped=true"
import script from "./DropdownSlider.vue?vue&type=script&lang=js"
export * from "./DropdownSlider.vue?vue&type=script&lang=js"
import style0 from "./DropdownSlider.vue?vue&type=style&index=0&id=3537f8c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3537f8c0",
  null
  
)

export default component.exports